import {ProjectFinancialDetail} from
'../dto/ProjectFinancialDetail';
export class ProjectFinancial {
  securityType: string;
  totalShares: number;
  projectFinancialDetails: ProjectFinancialDetail[];

}
